export const profileTemplateStyle = {
	wrapper: {
		background: 'var(--default-white)',
		borderRadius: '8px',
		padding: '24px',
		display: 'flex',
		flexDirection: 'column',
		height: '100%',
		boxShadow: 'var(--box-shadow--2)',

		'@media (min-width: 1200px)': {
			minHeight: 'calc(100vh - 128px)',
			overflow: 'hidden',
		},

		'@media (max-width: 1199.98px)': {
			minHeight: 'calc(100vh - 154px)',
		},

		'@media (max-width: 639.98px)': {
			minHeight: 'calc(100vh - 154px)',
		},
	},
};
